import { Alert, Button, Spinner } from "react-bootstrap";
import { useHistory, useParams } from "react-router-dom";
import { useGetRallyById } from "../../../../../api/jeep-rally/rally/rally.hooks";
import { formatRallyDate, normalizeRally } from "../utils/rally.utils";
import RallyCategorySection from "./_components/RallyCategorySection";
import RallyHighlightsSection from "./_components/RallyHighlightsSection";
import RallyInfoSection from "./_components/RallyInfoSection";
import RallyMediaSection from "./_components/RallyMediaSection";
import RallyStatsSection from "./_components/RallyStatsSection";

const RallyViewPage = () => {
  const history = useHistory();
  const { id } = useParams();

  const { data: rallyData, isLoading, isError, error } = useGetRallyById(id);
  const rally = normalizeRally(rallyData);

  const goBack = () => history.push("/jeep-rally/rallies");

  if (isLoading) {
    return (
      <div className="container-fluid">
        <div className="card">
          <div className="card-body">
            <div className="d-flex justify-content-center py-5">
              <Spinner animation="border" />
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (isError) {
    return (
      <div className="container-fluid">
        <div className="card">
          <div className="card-body">
            <Alert variant="danger" className="mb-3">
              {error?.response?.data?.message ||
                "Failed to load rally details."}
            </Alert>
            <Button variant="primary" onClick={goBack}>
              Back to Rallies
            </Button>
          </div>
        </div>
      </div>
    );
  }

  if (!rally) {
    return (
      <div className="container-fluid">
        <div className="card">
          <div className="card-body text-center py-5">
            <h5 className="mb-2">Rally not found</h5>
            <p className="text-muted mb-3">
              This rally may have been deleted or the link is invalid.
            </p>
            <Button variant="primary" onClick={goBack}>
              Back to Rallies
            </Button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container-fluid">
      <div className="card">
        <div className="card-header d-flex justify-content-between align-items-center flex-wrap gap-2">
          <div className="d-flex align-items-center gap-2">
            <button
              type="button"
              className="btn btn-link p-0 text-decoration-none"
              onClick={goBack}
              aria-label="Back to rallies list"
              title="Back"
            >
              <i className="bi bi-arrow-left fs-4" />
            </button>
            <div>
              <h4 className="card-title mb-0">{rally.name || "Rally Details"}</h4>
              <small className="text-muted">
                Updated {formatRallyDate(rally.updated_at)}
              </small>
            </div>
          </div>

          <div className="d-flex gap-2">
            <Button
              variant="outline-primary"
              onClick={() =>
                history.push(`/jeep-rally/rallies/edit/${rally._id || id}`)
              }
            >
              Edit Rally
            </Button>
            <Button variant="outline-secondary" onClick={goBack}>
              Back to List
            </Button>
          </div>
        </div>

        <div className="card-body">
          <RallyInfoSection rally={rally} />
          <hr />
          <RallyCategorySection rally={rally} />
          <hr />
          <RallyStatsSection rally={rally} />
          <hr />
          <RallyHighlightsSection highlights={rally.highlights} />
          <hr />
          <RallyMediaSection rally={rally} />
        </div>
      </div>
    </div>
  );
};

export default RallyViewPage;
